<template>
  <div id="app" ref="App">
    <router-view></router-view>
  </div>
</template>


<script>

  export default {
    name: 'app',
    data: () => {
      return {
        client_height: '',
      }
    },
    watch: {
      client_height: function (client_height) {
        this.changeHeight(client_height)
      }
    },
    mounted() {
      let that = this;
      this.client_height = `${document.documentElement.clientHeight}`;
      window.onresize = function temp() {
        that.client_height = `${document.documentElement.clientHeight}`;
      };
    },
    methods: {
      changeHeight(client_height) {
        this.$refs.App.style.height = `${client_height}px`
      },
    }
  }
</script>


<style>
  @import "./styles/init.css";
</style>
